import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { RoutesPaths } from "./Constant";
import Landing from "../Pages/Landing";
import PrivacyPolicy from "../Pages/PrivacyPolicy";
import TermsConditions from "../Pages/TermsConditions";
import Notfound from "../Components/Notfound";
import AboutUs from "../Pages/AboutUs";
import Denira from "../Pages/Denira";
import RenewableEnergy from "../Pages/RenewableEnergy";
import ContactUs from "../Pages/ContactUs";
import OilGas from "../Pages/OilGas";
import EpcInfrastructure from "../Pages/EpcInfrastructure";
import Esgcommitment from "../Pages/Esgcommitment";

export default function RouteComponent() {
  return ( 
    <>
      <Routes>
        <Route exact path={RoutesPaths.LANDING} element={<Landing />} />
        <Route exact path={RoutesPaths.ABOUTUS} element={<AboutUs />} />
        <Route exact path={RoutesPaths.CONTACTUS} element={<ContactUs />} />
        <Route exact path={RoutesPaths.DENIRA} element={<Denira />} />
        <Route exact path={RoutesPaths.RENEWABLEENERGY} element={<RenewableEnergy />} />
        <Route exact path={RoutesPaths.OILGAS} element={<OilGas />} />
        <Route exact path={RoutesPaths.EPC} element={<EpcInfrastructure />} />
        <Route exact path={RoutesPaths.ESG} element={<Esgcommitment />} />
        <Route exact path={RoutesPaths.PRIVACYPOLICY} element={<PrivacyPolicy />} />
        <Route exact path={RoutesPaths.TERMSCONDITIONS} element={<TermsConditions />} />
        <Route exact path={RoutesPaths.NOTFOUND} element={<Notfound />} />
        <Route path="*" element={<Navigate to={RoutesPaths.NOTFOUND} />} />
      </Routes>
    </>
  );
}
